export const parseTableResponse = (formatter, response) => response.map(data => formatter(data));

export const tableDataExtractionStrategy = data => data;